import styled from "styled-components";

export const StyledChartContainer = styled.div`
  width: 100%;
  margin-bottom: 2rem;
`;

export const StyledSection = styled.div`
  margin-bottom: 2rem;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
`;

export const StyledTitle = styled.h3`
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.2rem;
`;

export const StyledExplanation = styled.div`
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  line-height: 1.5;
`;
